jQuery(document).ready(function($) {
    $('.seventen-carousel').slick({
        fade: true,
        dots: true
    });
});